// Technical Skills organized by subcategories
export const TECHNICAL_SKILLS_CATEGORIES = [
  {
    name: 'Software Development',
    skills: [
      'Python Development', 'JavaScript Programming', 'Java Development',
      'C++ Programming', 'C# Development', 'Ruby Programming', 'PHP Development',
      'Swift Programming', 'Kotlin Development', 'Go Programming', 'Rust Development',
      'TypeScript Development', 'Scala Programming', 'R Programming',
      'MATLAB Programming', 'Software Design', 'Code Architecture',
      'Version Control', 'Testing Methods', 'Debugging',
      'Code Review', 'Development Tools', 'API Development',
      'Software Documentation', 'Development Standards', 'Code Optimization',
      'Software Security', 'Development Process', 'Software Maintenance'
    ]
  },
  {
    name: 'Web Development',
    skills: [
      'HTML5 Development', 'CSS3 Styling', 'React Development', 'Angular Development',
      'Vue.js Development', 'Node.js Development', 'Express.js Development',
      'Django Development', 'Flask Development', 'Ruby on Rails',
      'ASP.NET Development', 'Laravel Development', 'WordPress Development',
      'GraphQL Development', 'REST API Development', 'Frontend Development', 'Backend Development', 'Full Stack Development',
      'Web Frameworks', 'Web Security', 'Web Performance',
      'Responsive Design', 'Web Standards', 'Web Architecture',
      'Web Services', 'Web Analytics', 'Web Optimization',
      'Web Testing', 'Web Tools', 'Web Technologies'
    ]
  },
  {
    name: 'Database Management',
    skills: [
      'SQL Development', 'MySQL Management', 'PostgreSQL', 'MongoDB',
      'Oracle Database', 'SQL Server', 'Redis', 'Elasticsearch', 'Cassandra',
      'Neo4j', 'Database Design', 'Query Optimization', 'Data Modeling',
      'Database Security', 'Database Administration', 'Database Tools', 'Data Migration', 'Database Performance',
      'Database Architecture', 'Data Integrity', 'Database Standards',
      'Database Maintenance', 'Database Recovery', 'Database Monitoring'
    ]
  },
  {
    name: 'System Administration',
    skills: [
      'Linux Administration', 'Windows Server', 'System Security',
      'Server Management', 'Virtualization', 'Storage Management',
      'Backup Solutions', 'System Monitoring', 'Performance Tuning',
      'User Management', 'Service Management', 'Patch Management',
      'Disaster Recovery', 'System Documentation', 'Automation Scripts', 'System Management', 'Network Administration', 'Security Management',
      'System Tools', 'System Security', 'System Architecture',
      'System Documentation', 'System Standards', 'System Maintenance',
      'System Recovery', 'System Integration', 'System Optimization'
    ]
  },
  {
    name: 'Cloud Computing',
    skills: [
      'AWS Services', 'Azure Platform', 'Google Cloud', 'Cloud Architecture',
      'Cloud Security', 'Cloud Migration', 'Serverless Computing',
      'Container Management', 'Kubernetes', 'Docker', 'Cloud Storage',
      'Cloud Networking', 'Cloud Monitoring', 'Cloud Cost Management',
      'Multi-cloud Strategy', 'Cloud Services', 'Cloud Integration',
      'Cloud Tools', 'Cloud Standards', 'Cloud Performance',
      'Cloud Monitoring', 'Cloud Development', 'Cloud Operations',
      'Cloud Strategy', 'Cloud Solutions', 'Cloud Optimization'
    ]
  },
  {
    name: 'DevOps',
    skills: [
      'CI/CD Pipeline', 'Jenkins', 'Git Version Control', 'Infrastructure as Code',
      'Ansible', 'Terraform', 'Puppet', 'Chef', 'Docker Compose',
      'Kubernetes Orchestration', 'Monitoring Tools', 'Log Management',
      'Performance Tuning', 'Security Integration', 'Deployment Automation', 'Continuous Integration', 'Continuous Deployment', 'Configuration Management',
      'Container Management', 'Automation Tools', 'DevOps Tools', 'DevOps Practices', 'Pipeline Management',
      'Release Management', 'DevOps Security', 'DevOps Monitoring',
      'DevOps Strategy', 'DevOps Culture', 'DevOps Standards'
    ]
  },
  {
    name: 'Data Science',
    skills: [
      'Data Analysis', 'Machine Learning', 'Statistical Analysis',
      'Data Visualization', 'Big Data Processing', 'Predictive Modeling',
      'Data Mining', 'Natural Language Processing', 'Computer Vision',
      'Deep Learning', 'Neural Networks', 'Feature Engineering',
      'Model Evaluation', 'Data Preprocessing', 'Algorithm Development', 'Data Tools', 'Data Standards', 'Data Architecture',
      'Data Strategy', 'Data Security', 'Data Quality',
      'Data Integration', 'Data Management', 'Data Operations'
    ]
  },
  {
    name: 'Artificial Intelligence',
    skills: [
      'AI Programming', 'Neural Networks', 'Deep Learning', 'Machine Learning',
      'Natural Language Processing', 'Computer Vision', 'Robotics',
      'Expert Systems', 'Genetic Algorithms', 'Reinforcement Learning',
      'AI Ethics', 'AI Integration', 'AI Optimization', 'AI Testing',
      'AI Deployment', 'AI Algorithms', 'Neural Networks',
      'AI Tools', 'AI Development', 'AI Implementation',
      'AI Strategy', 'AI Ethics', 'AI Standards',
      'AI Security', 'AI Operations', 'AI Integration'
    ]
  },
  {
    name: 'Cybersecurity',
    skills: [
      'Network Security', 'Application Security', 'Cloud Security',
      'Penetration Testing', 'Security Auditing', 'Incident Response',
      'Threat Analysis', 'Vulnerability Assessment', 'Security Architecture',
      'Encryption', 'Authentication', 'Authorization', 'Security Monitoring',
      'Compliance Management', 'Security Tools', 'Security Management', 'Threat Analysis', 'Security Tools',
      'Security Standards', 'Security Architecture', 'Security Operations',
      'Security Strategy', 'Security Testing', 'Security Monitoring',
      'Incident Response', 'Security Compliance', 'Risk Management',
      'Security Assessment', 'Security Planning', 'Security Implementation'
    ]
  },
  {
    name: 'Network Engineering',
    skills: [
      'Network Design', 'Network Security', 'Network Protocols', 'Routing',
      'Switching', 'Firewall Management', 'VPN Configuration', 'Load Balancing',
      'Network Monitoring', 'Wireless Networks', 'Network Troubleshooting',
      'Network Documentation', 'Network Performance', 'Network Automation',
      'Network Virtualization', 'Network Design', 'Network Security', 'Network Management',
      'Network Protocols', 'Network Tools', 'Network Standards',
      'Network Architecture', 'Network Performance', 'Network Monitoring',
      'Network Operations', 'Network Strategy', 'Network Implementation',
      'Network Integration', 'Network Planning', 'Network Optimization'
    ]
  },
  {
    name: 'Mobile Development',
    skills: [
      'iOS Development', 'Android Development', 'React Native', 'Flutter Development',
      'Xamarin Development', 'Mobile UI Design', 'App Performance',
      'Mobile Security', 'Push Notifications', 'Mobile Analytics',
      'App Store Optimization', 'Mobile Testing', 'Hybrid Apps',
      'Progressive Web Apps', 'Mobile Backend', 'Mobile Architecture', 'Mobile Security', 'Mobile UI/UX',
      'Mobile Testing', 'Mobile Tools', 'Mobile Standards',
      'Mobile Performance', 'Mobile Integration', 'Mobile Strategy',
      'Mobile Operations', 'Mobile Development', 'App Development',
      'Cross-platform Development', 'Mobile Design', 'Mobile Analytics'
    ]
  },
  {
    name: 'IT Support',
    skills: [
      'Technical Support', 'Help Desk', 'System Troubleshooting',
      'User Support', 'Support Tools', 'Support Standards',
      'Problem Resolution', 'Support Documentation', 'Support Strategy',
      'Support Operations', 'Service Management', 'Incident Management',
      'Change Management', 'Asset Management', 'Support Planning'
    ]
  }
];

// Export flattened list for backward compatibility
export const TECHNICAL_SKILLS = TECHNICAL_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
